import { render, staticRenderFns } from "./ImageItem.vue?vue&type=template&id=0bdbd152&scoped=true&"
import script from "./ImageItem.vue?vue&type=script&lang=ts&"
export * from "./ImageItem.vue?vue&type=script&lang=ts&"
import style0 from "./ImageItem.vue?vue&type=style&index=0&id=0bdbd152&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bdbd152",
  null
  
)

export default component.exports